import React from 'react'

import { Container, Card } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'

import Header from 'src/components/Layout/Header/Header'
import ForumForm from 'src/components/Forum/ForumForm'
import usePermission from 'src/hooks/usePermission'
import Error401 from 'src/pages/Error/401.page'
import { route } from 'src/utils/routes'

const ForumCreate: React.FC = () => {
  const history = useHistory()
  const { userCan } = usePermission()

  if (!userCan('create_forum')) return <Error401 />

  return (
    <>
      <Header
        title="New Community"
        backText="Communities"
        onBack={() => history.push(route('forums'))}
      />
      <div className="page-container">
        <Container>
          <Card>
            <Card.Header>
              <Card.Title>Community Details</Card.Title>
            </Card.Header>
            <Card.Body className="pt-0">
              <ForumForm />
            </Card.Body>
          </Card>
        </Container>
      </div>
    </>
  )
}

export default ForumCreate
